import { useState } from 'react'
import { singletonHook } from 'react-singleton-hook'

import Api, { ApiResponseCodes } from './api'
import { FORM_NO_SUBMIT, CAPTCHA_TOKEN_KEY } from './constants'
import { getRecaptchaToken } from './recaptcha'
import { CaptchaConfig } from '../components/templates/Form/Container/types'

export enum FormStatuses {
  Success = 'success',
  Error = 'error'
}

let formSubmitStatus: string = ''
let updateFormSubmitStatusSubscribers = (value: string) => {
  formSubmitStatus = value
}

export const getFormSubmitStatus = () => formSubmitStatus

export const setFormSubmitStatus = (value: string) => {
  formSubmitStatus = value
  updateFormSubmitStatusSubscribers(formSubmitStatus)
}

export const useInitFormSubmitStatus = singletonHook(
  getFormSubmitStatus,
  () => {
    const [status, setStatus] = useState<string>(getFormSubmitStatus)
    updateFormSubmitStatusSubscribers = setStatus
    return status
  }
)

export const handleFormSubmit = async (
  url: string,
  values: Record<string, unknown>,
  headers: Record<string, string>,
  captcha?: CaptchaConfig
  // eslint-disable-next-line max-params
) => {
  let formData: Response | null = null

  const token = await getRecaptchaToken(captcha)

  if (captcha?.config?.enabled && !token) {
    setFormSubmitStatus(FormStatuses.Error)
    return { formData }
  }

  const valuesToSubmit = Object.fromEntries(
    Object.entries(values).filter(([key]) => !key.endsWith(FORM_NO_SUBMIT))
  )
  let payload = { ...valuesToSubmit } as Record<string, unknown>

  // Find and replace captcha token in payload structure
  if (token) {
    const payloadString = JSON.stringify(payload)
    if (payloadString.includes(CAPTCHA_TOKEN_KEY)) {
      const updatedPayloadString = payloadString.replace(
        new RegExp(`"${CAPTCHA_TOKEN_KEY}":"[^"]*"`, 'g'),
        `"${CAPTCHA_TOKEN_KEY}":"${token}"`
      )
      payload = { ...JSON.parse(updatedPayloadString) }
    } else {
      payload = { ...payload, [CAPTCHA_TOKEN_KEY]: token }
    }
  }
  const API_FORM_DATA = {
    url,
    options: {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    }
  }

  formData = await Api.fetch(API_FORM_DATA.url, API_FORM_DATA.options)

  if (
    !formData ||
    (formData.status !== ApiResponseCodes.RC200 &&
      formData.status !== ApiResponseCodes.RC201)
  ) {
    setFormSubmitStatus(FormStatuses.Error)
  } else {
    setFormSubmitStatus(FormStatuses.Success)
  }
  return { formData }
}
